import { FormErrorsAlert, FormItem } from '@framework/form';
import { Collapse } from 'antd';
import React from 'react';
import { BooleanConditionEditorInput } from '../../../../inputs/expressions-editor/conditions/BooleanConditionEditorInput';
import { StyledDrawerCollapse } from '../../../../ui/drawer/StyledDrawerCollapse';
import { WidgetDirectivesInput } from '../../../directives/WidgetDirectivesInput';
import { IWidgetType } from '../../IWidgetType';
import { Widget, WidgetMainType } from '../../Widget';

const { Panel } = Collapse;

export interface IWidgetConfigFormProps {
  widgetType: IWidgetType<Widget> | null | undefined;
  widget: Widget | null | undefined;
  isTableColumn?: boolean;
}

export function WidgetConfigForm(props: IWidgetConfigFormProps) {
  const { widgetType, widget, isTableColumn = false } = props;

  if (!widget || !widgetType) return null;

  return (
    <>
      <FormErrorsAlert />
      {/* Se si rimuove il collapse di default mostriamo direttamente il componente
            se necessario il Collapse deve essere gestito nel componente */}
      {widgetType.configComponent && (
        <>
          {widgetType.configOptions?.removeCollapsePanel && (
            <>
              <widgetType.configComponent
                widget={widget}
                componentLayout={{ isTableColumn }}
                preview
              />
              <WidgetDirectivesInput widget={widget} widgetType={widgetType} />
            </>
          )}
        </>
      )}
      <StyledDrawerCollapse
        defaultActiveKey={['rules', 'general', 'view']}
        ghost
      >
        {widgetType.configComponent && (
          <>
            {widgetType.configOptions?.removeCollapsePanel ? null : (
              <Panel header="Impostazioni Generali" key="general">
                <widgetType.configComponent
                  widget={widget}
                  componentLayout={{ isTableColumn }}
                  preview
                />
                <WidgetDirectivesInput
                  widget={widget}
                  widgetType={widgetType}
                />
              </Panel>
            )}
          </>
        )}
        {widgetType.rules.length > 0 && (
          <Panel header="Regole di Validazione" key="rules">
            {widgetType.rules.map((rule, index) => (
              <rule.configComponent key={index} widget={widget} />
            ))}
          </Panel>
        )}
        {!widgetType.hideFlags && (
          <Panel header="Regole di Visualizzazione" key="view">
            <FormItem name="visible" label="Visibile">
              <BooleanConditionEditorInput name="visible" label="Visibile" />
            </FormItem>
            {/* I widget grafici non possono essere disabilitati */}
            {widgetType.mainType !== WidgetMainType.Graphic &&
              // I widget sempre abilitati non hanno la possibilità di essere disabilitati
              !widgetType.alwaysEnabled && (
                <FormItem name="enabled" label="Abilitato">
                  <BooleanConditionEditorInput
                    name="enabled"
                    label="Abilitato"
                  />
                </FormItem>
              )}
          </Panel>
        )}
      </StyledDrawerCollapse>
    </>
  );
}
